import { DatePipe } from "@angular/common";
import { Component, Input, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { IonRefresher } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { filter, take } from "rxjs/operators";
import { Building } from "src/components/shared-components/class/general-classes/building";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { selectedBuilding } from "src/components/shared-components/state/selectors/building.selector";
import { StaticClass } from "src/components/shared-components/class/general-classes/static-classes";
import { iConnToolbarColour } from "src/components/shared-components/interfaces/iConnToolbarColour";
import { WeeklyPlanning } from "src/model/class/general classes/weekly-planning";
import { ApiErrorType } from "src/model/enum/enumApiErrorType";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { iTranslation } from "src/components/shared-components/interfaces/iTranslation";
import { iWeeklyPlanning } from "src/model/interface/iWeekly-planning";
import { AlertService } from "src/service/alert.service";
import { EnvironmentService } from "src/service/environment.service";
import { EventService } from "src/service/event.service";
import { LoaderService } from "src/service/loader.service";
import { LoggerService } from "src/service/logger.service";
import { NetworkService } from "src/service/network.service";
import { SystemRouterService } from "src/service/system-router.service";
import { WeeklyPlanningService } from "src/service/weekly-planning.service";
import { canEditWeeklyPlanningOption } from "src/state/selectors/server-settings-selector";
import { ConnectionType } from "src/components/shared-components/enum/enumSettings";

@Component({
    selector: "app-weekly-plannings-list",
    templateUrl: "./weekly-plannings-list.component.html",
    styleUrls: ["./weekly-plannings-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WeeklyPlanningsListComponent
  implements OnInit, iTranslation, OnDestroy, iEvent, iConnToolbarColour {
  private _logContext: string = "Weekly-plannings-list.component";

  //#region Subcriptions to "_store.select(...)" Observables
  private _selectCanEditOptionSub: Subscription = null;

  //#endregion

  //
  private _weeklyPlanningsSubscribtion: Subscription = null;
  private _networkServiceSubscription: Subscription = null;

  /**
   * Flag value; if the ionic-refesher component has been activated, it is set to TRUE; otherwise, it is set to FALSE.
   *
   * It is useful to manage the supervisions-list re-initialisation caused by the ionic-refesher activation; in that case, the refresher is immediately
   * completed.
   */
  private _isRefreshOnGoing: boolean = false;

  private _lblNewWeeklyPlanning: string = "";

  /**Flag value; if the skeleton component MUST be showed, it is set to TRUE, otherwise, to FALSE. */
  public isSpookySkeleton: boolean = false;

  /**
   * Height of one row, used to fill the loading list with just enough skeletons: mirrors
   * `.skeleton-item` in the SCSS (`--min-height`, the rows carry no vertical margins).
   */
  public readonly skeletonRowHeight: number = 72;

  //public weeklyPlannings: Array<WeeklyPlanning> = null;
  public weeklyPlannings: Array<WeeklyPlanning> = new Array<WeeklyPlanning>();

  public showErrorContent: boolean = false;

  public _eventSubscriptions: Array<Subscription> = null;

  /**Flag value; if the "supervisions-list" has been properly initialised from public Observable, it is set to TRUE; otherwise it is set to FALSE.
   *
   * NOTE: Generally, when it is set to FALSE, the page should display the "skeleton" list
   */
  public isweeklyPlanningsInitialized: boolean = false;

  public searchText: string = "";
  public lblSearchBarPlaceholder: string = "";
  public lblNoContentText: string = "";

  public lblFunctionalityNotSupported: string = "Funzionalità non supportata";
  public isFunctionalityNotImplemented: boolean = false;

  public translateSubscription: Subscription;

  public event: any;

  public toolBarColor: string = "primary";
  public currentConnectionType: ConnectionType = ConnectionType.NONE;

  @Input("allowEdit") allowEdit: boolean = true;
  @Input("allowDelete") allowDelete: boolean = true;

  @Input("allowDetectionListChange") allowDetectionListChange: boolean = true;

  @ViewChild("refresherRef", { static: false }) refresherRef: IonRefresher;

  constructor(
    private _weeklyPlanningService: WeeklyPlanningService,
    private _alertService: AlertService,
    private _translateService: TranslateService,
    private _eventService: EventService,
    private _networkService: NetworkService,
    private _systemRouterService: SystemRouterService,
    private _loaderController: LoaderService,
    private _datepipe: DatePipe,
    private _loggerService: LoggerService,
    private _store: Store,
    private _environmentService: EnvironmentService,
  ) {
    //this.weeklyPlanningService.Init();
  }

  ngOnInit() {
    this._loggerService.log(
      LogLevel.LOG_INFO,
      this._logContext,
      this._logContext,
      "ngOnInit()",
      "START",
    );

    this._isRefreshOnGoing = false;
    //this.isRefreshOngoingPublic = false;
    this.isSpookySkeleton = false;
    this.isweeklyPlanningsInitialized = false;

    this.loadTranslation();
    this.subscribeTranslationEvent();
    this.subscribeNetworkServiceData();
    this.subscribeEvents();
    this.subscribeWeeklyPlanningService();

    this.loadSettings();

    this.searchText = "";
    this._weeklyPlanningService.GetweeklyPlanning();
  }

  ngOnDestroy() {
    this._loggerService.log(
      LogLevel.LOG_INFO,
      this._logContext,
      this._logContext,
      "ngOnDestroy()",
      "DESTROY",
    );

    this.unsubscribeStoreSelect();

    this.unsubscribeEvents();

    if (this._networkServiceSubscription) {
      this._networkServiceSubscription.unsubscribe();
    }

    if (this._weeklyPlanningService != null) {
      this._weeklyPlanningsSubscribtion.unsubscribe();
    }

    if (this.translateSubscription) {
      this.translateSubscription.unsubscribe();
    }
  }

  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnweeklyPlanningChange.pipe(
        filter(() => this.allowDetectionListChange),
      ).subscribe(async (idWeeklyPlanningChanged_ClientID: string) => {
        this._loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          " _eventService ",
          " OnweeklyPlanningChange ",
          "ALLOWED DETECTION LIST CHANGE: " +
          this.allowDetectionListChange +
          " - RECEIVED NEW VALUES TO : " +
          idWeeklyPlanningChanged_ClientID,
        );

        /* The list refreshes on its own from the weeklyPlanningList store subscription, so a remote
         * MQTT change does not need the "data updated" popup: the update is applied silently. */
      }),
    );
  } //

  unsubscribeEvents(): void {
    for (const sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }

  /** Action to execute when the refresh is called */
  public async doRefresh() {
    this._weeklyPlanningService.needToInitialize = true;
    this._isRefreshOnGoing = true;
    this.isSpookySkeleton = true;

    this._weeklyPlanningService.Init();
  }

  /**
   *
   *  Insert new weekly planning when user press plus button on header. It assign a default name to weekly planning and it set it to active.
   *  If API weekly planning creation end successfully than redirect to weekly planning editor route (/config-weekly-planning/{idNewWeeklyPlanning}) otherwise show error message.
   *  During creation weekly planning process, it show a loader popup for entertaining user and don't allow creation of new weekly planning in same time.
   *
   *
   */
  public async onClickNewWeeklyPlanning() {
    await this._loaderController.presentLoaderWaiting();

    try {
      let newWeeklyPlanning: WeeklyPlanning = new WeeklyPlanning();
      newWeeklyPlanning.name = this._lblNewWeeklyPlanning;
      newWeeklyPlanning.description = this._lblNewWeeklyPlanning;
      newWeeklyPlanning.resettimestring = this.getDate(
        newWeeklyPlanning.resettimestring,
      );
      newWeeklyPlanning.active = false;

      /* Create the planning already bound to the first environment of the current area, so it has
       * an area from the start
       */
      newWeeklyPlanning.idEnvironment = await this.getFirstAreaEnvironmentId();

      newWeeklyPlanning =
        await this._weeklyPlanningService.InsertweeklyPlanning(
          newWeeklyPlanning as iWeeklyPlanning,
        );
      this._systemRouterService.navigateToWeeklyPlanningEditData(
        newWeeklyPlanning.id,
      );
      await this._loaderController.dismissLoaderWaiting();
    } catch (error) {
      this._loggerService.log(
        LogLevel.LOG_ERROR,
        this._logContext,
        this._logContext,
        "onClickNewWeeklyPlanning()",
        "ERROR: " + error.message,
      );
      await this._loaderController.dismissLoaderWaiting();

      this._alertService.presentAlertSomethingWrong();
    }
  }

  /**
   * Id of the first environment available in the currently selected building's area, or -1 when the
   * area has no environments (or none can be fetched). Used to bind a newly-created planning to an
   * environment right away, so it is created with an area.
   */
  private async getFirstAreaEnvironmentId(): Promise<number> {
    try {
      const building: Building = await this._store
        .select(selectedBuilding)
        .pipe(take(1))
        .toPromise();
      const idArea: number = building ? building.idAreaLocal : null;

      const environments: GenericApiData = await this._environmentService
        .getEnvironments(idArea, null, false)
        .toPromise();

      const firstEnvironment = environments?.data?.[0];
      return firstEnvironment ? firstEnvironment.id : -1;
    } catch (error) {
      this._loggerService.log(
        LogLevel.LOG_ERROR,
        this._logContext,
        this._logContext,
        "getFirstAreaEnvironmentId()",
        "Unable to resolve a default environment: " + error,
      );
      return -1;
    }
  }

  /**
   * Force reload data after "Something went wrong" button refresh click
   */
  public forceReloadData() {
    this._weeklyPlanningService.reloadServiceData();
  }

  public loadTranslation() {
    this._translateService
      .get([
        "dictionary.noWeelyPlanningFounded",
        "dictionary.searchWeeklyPlanning",
        "dictionary.functionalityNotSupported",
        "dictionary.newWeeklyPlanning",
      ])
      .subscribe((translateString) => {
        this._lblNewWeeklyPlanning =
          translateString["dictionary.newWeeklyPlanning"];
        this.lblNoContentText =
          translateString["dictionary.noWeelyPlanningFounded"];
        this.lblSearchBarPlaceholder =
          translateString["dictionary.searchWeeklyPlanning"];
        this.lblFunctionalityNotSupported =
          translateString["dictionary.functionalityNotSupported"];
      });
  }

  public subscribeTranslationEvent() {
    this.translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();
      },
    );
  }

  /**
   * Gate creating and deleting plannings on the "edit registry data" server permission.
   *
   * Both are registry operations, so residents (condomini) — who only hold the daily-sector
   * permission — get neither the "new planning" FAB nor the delete option on the rows; they
   * still reach an existing planning to edit its time-slices. See
   * {@link canEditWeeklyPlanningOption}.
   */
  private loadSettings(): void {
    this._selectCanEditOptionSub = this._store
      .select(canEditWeeklyPlanningOption)
      .subscribe((canEditOption) => {
        this.allowEdit = canEditOption;
        this.allowDelete = canEditOption;
      });
  }

  /**
   * Handle errors in api call which require peculiar reactions from the page; this includes cases where the error is propagated through subject.error()
   * @param error
   */
  private async handlePeculiarApiResponseError(error: any): Promise<void> {
    switch (error.status) {
      /*This usually is associated with attempts by the app to require access to server-side features which are NOT currently supported*/
      case ApiErrorType.NOT_FOUND:
        this.isFunctionalityNotImplemented = true;
        break;

      default:
        this.handleApiResponseError();
        break;
    }
  }

  /**
   * Handle API error
   */
  private async handleApiResponseError(): Promise<void> {
    this.weeklyPlannings = new Array<WeeklyPlanning>();
    this.showErrorContent = true;
    await this._loaderController.dismissLoaderWaiting();
  }

  /**
   * Subscribe to the public Observable of "NetworkService", which emits each time the connection change of type/state. A local property is changed to
   * reflect the new value.
   */
  private subscribeNetworkServiceData(): void {
    this._networkServiceSubscription =
      this._networkService.currentConnectionType.subscribe(
        (currentConnectionType: ConnectionType) => {
          this.currentConnectionType = currentConnectionType;

          this.toolBarColor = StaticClass.getComponentColorByNetworkState(
            this.currentConnectionType,
          );
        },
      );
  }

  /**
   * Subscribte to weekly service data
   */
  private subscribeWeeklyPlanningService(): void {
    this._weeklyPlanningsSubscribtion =
      this._weeklyPlanningService.weeklyPlanningList
        .pipe(filter((res) => res !== null))
        .subscribe(
          async (listWeeklyPlanning: Array<WeeklyPlanning>) => {
            await this._alertService.clearAlertOk();

            if (
              this._weeklyPlanningService
                .isErrorInGetWeeklyPlanningListAPIRequest
            ) {
              this.isweeklyPlanningsInitialized = false;

              if (this._isRefreshOnGoing) {
                await this.refresherRef.complete();
                this.isSpookySkeleton = false;
                this._isRefreshOnGoing = false;
              }
              this.handleApiResponseError();
            } else {
              this.weeklyPlannings = listWeeklyPlanning || [];

              this.isweeklyPlanningsInitialized = true;
              this.showErrorContent = false;

              if (this._isRefreshOnGoing) {
                setTimeout(async () => {
                  this.refresherRef.disabled = true;
                  await this.refresherRef.complete();
                  /* IMPORTANT WORKAROUND  */
                  /*The temporised toggling of refresher's property "disabled" value is necessary in order to side-step the bug 
                in which, after its first activation, the refresher is randomly activated each time the user "scroll down" the page.
                */
                  setTimeout(() => {
                    this.refresherRef.disabled = false;
                  }, 100);

                  this.isSpookySkeleton = false;
                  this._isRefreshOnGoing = false;
                }, 500);
              }

              await this._loaderController.dismissLoaderWaiting();
              this._loggerService.log(
                LogLevel.LOG_INFO,
                this._logContext,
                " _weeklyPlanningService - weeklyPlanningList",
                " subscribeWeeklyPlanningService() ",
                "After loader dismissal",
              );
            }
          },
          (error) => {
            this._loggerService.log(
              LogLevel.LOG_ERROR,
              this._logContext,
              " _weeklyPlanningService - weeklyPlanningList",
              " subscribeWeeklyPlanningService() ",
              "ERROR FROM OBSERVABLE LIST. Status " +
              error.status +
              " , " +
              error.message,
            );
            this.handlePeculiarApiResponseError(error);
          },
        );
  }

  /**
   *
   * @param time date written as a string
   * @returns date written as a string with a different format (dd-MM-yyyy HH:mm:ss)
   *
   */
  private getDate(time: string): string {
    const date = new Date(time);
    const newDate = new Date(
      1,
      1,
      1,
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      0,
    );
    if (newDate.toString() != "Invalid Date") {
      time = this._datepipe.transform(newDate, "dd-MM-yyyy HH:mm:ss");
    }
    return time;
  }

  //#region Unsubscribe from "_store.selec(...)" Observable
  /**
   * This method handles the unsunìbscription from the Observables returned by the "_store.select(...)" invocations.
   * It SHOULD BE CALLED EACH TIME THE DATA STREAMS ARE NOT NEEDED ANYMORE; this means in:
   *
   * * OnDestroy() [Components/Services]
   * * OnViewWillLeave() [Pages]
   */
  private unsubscribeStoreSelect(): void {
    if (this._selectCanEditOptionSub) {
      this._selectCanEditOptionSub.unsubscribe();
    }
  }
  //#endregion
}
